import { Dispatch, SetStateAction, createContext } from "react";

export type StepperContextProps = {
  current: number;
  setCurrent: Dispatch<SetStateAction<number>>;
  currentId: string;
  setCurrentId: Dispatch<SetStateAction<string>>;
  focus: number;
  setFocus: Dispatch<SetStateAction<number>>;
  onComplete?: () => void;
  items?: NodeListOf<HTMLElement>;
  allCompleted?: boolean;
  setAllCompleted?: Dispatch<SetStateAction<boolean>>;
  allowNavigateToPrevStep?: boolean;
};

export const StepperContext = createContext<StepperContextProps>({
  current: 0,
  currentId: "",
  focus: 0,
  setFocus: () => undefined,
  setCurrent: () => undefined,
  setCurrentId: () => undefined,
});
